import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo 取得停登訊息
 */
const GetAlertMessage = [
    'POST',
    RouteUrlList.API_ServiceAlert.path,
    {},
    200,
    {
        requestToken: null,
        isShowAlertMessage: false,
        // 注意：欄位名必須是 alertHash（ServiceAlert.ts 讀 res.alertHash），用 alertId 會讓去重失效
        alertHash: '14e66f70811911587774fc33aa8d356b5fcd344f7a391b246c42c39fcf7d2c27',
        alertType: 1, // 0:無訊息 1:Warning(跳彈窗) 2:Block
        alertTitle: '系統公告',
        alertMessage: '這是測試用公告訊息',
        idleTimeoutHintMinutes: 9,
        status: true,
        title: 'qwe',
        message: '123',
        errorCode: null
    }
];
export default GetAlertMessage;
